<script>
import TourClientItem from '@/modules/Tour/Client/Item';

export default {
  data() {
    return {
      title: 'Тур',
      item: new TourClientItem(),
    };
  },
  mounted() {
    this.item.init();
  },
};
</script>
<template>
  <TemplateItem
    :title="title"
    wrap
  >
    <component
      :module="item"
      :is="item.component"
    ></component>
  </TemplateItem>
</template>
